import React, {PropTypes} from 'react';
import OrderModalStep from '../OrderModalStep/OrderModalStep';
import FbPage from '../../common/Facebook/FbPage';
import FbLikeButton from '../../common/Facebook/FbLikeButton';
import './OrderSuccessStep.less';

class OrderSuccessStep extends React.Component {
  render () {
    const {onPrimaryAction, onClose} = this.props;

    return (
      <OrderModalStep className="order-success-step"
        title="Dziękujemy!"
        primaryActionTitle="Zamknij"
        onPrimaryAction={onPrimaryAction}
        onClose={onClose}
        footer={(<FbLikeButton />)}>
        <div>
          <p>Zamówienie w trakcie realizacji!</p>
          <p>Dostawca zadzwoni do Ciebie 5 min. przed dostawą.</p>
          <p>W razie pytań, prosimy o kontakt telefoniczny:<br/>
            <a href="tel:799939443">799-939-443</a>
          </p>
        </div>
        <aside>
          <FbPage />
        </aside>
      </OrderModalStep>
    );
  }
}

OrderSuccessStep.propTypes = {
  onPrimaryAction: PropTypes.func,
  onClose: PropTypes.func
};

export default OrderSuccessStep;



// WEBPACK FOOTER //
// ./src/components/OrderModal/OrderSuccessStep/OrderSuccessStep.js